import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    onConfirm: () => void,
    onExit: () => void,
    onCancel: () => void
}

const OrderSerologyConfirmation = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onExit}>
            <Modal.Header closeButton>
                <Modal.Title>Streamlined Serology</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ textAlign: 'center', marginBottom: 10 }}>Donor Shield Donation saved successfully.</div>
                <div style={{ textAlign: 'center' }}>Would you like to order a Streamlined Serology Kit?</div>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Yes</Button>
                <Button onClick={props.onCancel}>No</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default OrderSerologyConfirmation;
